import { createFileRoute, redirect } from "@tanstack/react-router";

/** Endereço antigo: redireciona para /produtos mantendo os parâmetros. */
export const Route = createFileRoute("/_authenticated/sabores")({
  validateSearch: (s: Record<string, unknown>): { editar?: string | undefined } => ({
    editar: typeof s["editar"] === "string" ? (s["editar"] as string) : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/produtos", search });
  },
});
